// extracted by mini-css-extract-plugin
module.exports = {"mobileChatHolder":"MobileChat_mobileChatHolder__3Ikd3","mobileChatMessageHolder":"MobileChat_mobileChatMessageHolder__24jUp"};